<div class="display-grid ml-10 color-accent">
  <span class="footer">&copy;2020 ITMCode</span>
  <span *ngIf="opened" class="footer">wersja: {{ appVersion }},</span>
  <span *ngIf="opened" class="footer">wersja API: {{ apiVersion }}</span>
</div>
